const Skills = [
    // Languages
    { title: "Java", type: "language" },
    { title: "Python", type: "language" },
    { title: "TypeScript", type: "language" },
    { title: "Kotlin", type: "language" },
    { title: "JavaScript", type: "language" },
    { title: "SQL", type: "language" },

    // Frameworks
    { title: "Spring Boot", type: "framework" },
    { title: "Node.js", type: "framework" },
    { title: "Express.js", type: "framework" },
    { title: "PySpark", type: "framework" },
    { title: "Apache Airflow", type: "framework" },
    { title: "React.js", type: "framework" },
    { title: "GraphQL", type: "library" },

    // Infra & data
    { title: "AWS", type: "tools" },
    { title: "Docker", type: "tools" },
    { title: "Kubernetes", type: "tools" },
    { title: "Terraform", type: "tools" },
    { title: "Databricks", type: "tools" },
    { title: "Elasticsearch", type: "tools" },
    { title: "PostgreSQL", type: "database" },
    { title: "MongoDB", type: "database" }
]

export default Skills;
